import { render } from "./CheckFaceInfo.vue?vue&type=template&id=58d56ae8"
import script from "./CheckFaceInfo.vue?vue&type=script&lang=js"
export * from "./CheckFaceInfo.vue?vue&type=script&lang=js"

import exportComponent from "C:\\ANPHUVIET\\ebanking-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__